export * from './bank-account-type.enum';
export * from './customer-specification.enum';
export * from './marital.enum';
export * from './type-of-customer.enum';
export * from './contract-sign-type.enum';
